var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vueper-slides',{scopedSlots:_vm._u([{key:"bullet",fn:function({ active, slideIndex, index }){return [_c('button',{attrs:{"type":"button"}})]}}])},_vm._l((_vm.reportPhotos),function(slide,i){return _c('vueper-slide',{key:i,attrs:{"image":slide}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }